import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import QueryBuilder from './QueryBuilder';
import DataFetcher from './DataFetcher';
import QueryResult from './QueryResult';
export default function Controller(searcherRegs, options) {
  var searcherArgs = null;
  var optionsArgs = null;

  if (Array.isArray(searcherRegs)) {
    searcherArgs = searcherRegs;
    optionsArgs = options;
  } else {
    optionsArgs = searcherRegs;
  } //Vars


  this._searchers = [];
  this.activeDataFetcher = null;
  this.onErrorHandlers = [];
  this.onAddSearcherHandlers = [];
  this.onSelectHandlers = [];
  this.onInspectHandlers = [];
  this.onPeakHandlers = [];
  this.blankBehavior = "none"; //none, search
  //Options

  if (optionsArgs !== null) {
    if (typeof optionsArgs.onError === "function") this.addErrorHandler(optionsArgs.onError);
    if (optionsArgs.blankBehavior) this.blankBehavior = optionsArgs.blankBehavior;
  }

  this.idSerial = 0;

  if (searcherArgs !== null) {
    this.allSearchersProcessed = Promise.resolve('success');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = searcherArgs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var searcherArg = _step.value;
        this.addSearcher(searcherArg);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}
Controller.prototype = {
  set searchers(searchers) {
    this._searchers = [];
    this.allSearchersProcessed = Promise.resolve('success');
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = searchers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var searcher = _step2.value;
        this.addSearcher(searcher);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

};

Controller.prototype.addOnSelectHandler = function (callback) {
  this.onSelectHandlers.push(callback);
};

Controller.prototype.onSelect =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(result) {
    var completedResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof result !== 'undefined')) {
              _context.next = 9;
              break;
            }

            if (!result.isNewQuery()) {
              _context.next = 5;
              break;
            }

            this.callSelectHandlers(result);
            _context.next = 9;
            break;

          case 5:
            _context.next = 7;
            return result.complete();

          case 7:
            completedResult = _context.sent;
            this.callSelectHandlers(completedResult);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

Controller.prototype.callSelectHandlers = function (result) {
  if (result.searcher) result.searcher._onSelect(result);
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = this.onSelectHandlers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var onSelectHandler = _step3.value;
      onSelectHandler(result);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
};

Controller.prototype.addErrorHandler = function (callback) {
  this.onErrorHandlers.push(callback);
};

Controller.prototype.onError = function (searcher, errorThrown) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = this.onErrorHandlers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var onErrorHandler = _step4.value;
      onErrorHandler(searcher, errorThrown);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
};

Controller.prototype.addSearcher = function (searcherReg) {
  var searcher = searcherReg;
  if (typeof searcherReg.searcher !== 'undefined') searcher = searcherReg.searcher;
  searcher.id = this.idSerial++;

  this._searchers.push(searcher);

  this.allSearchersProcessed = Promise.all([this.allSearchersProcessed, this.thisSearcherProcessed(searcher)]);
};

Controller.prototype.thisSearcherProcessed =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(searcher) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return searcher.ready();

          case 3:
            this.onAddSearcher();
            _context2.next = 9;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            this.removeSearcher(searcher);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 6]]);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}();

Controller.prototype.removeSearcher = function (searcher) {
  for (var i = 0; i < this._searchers.length; i++) {
    var thisSearcher = this._searchers[i];

    if (thisSearcher.id === searcher.id) {
      this._searchers.splice(i, 1);

      break;
    }
  }
};

Controller.prototype.addOnAddSearcherHandler = function (callback) {
  this.onAddSearcherHandlers.push(callback);
};
/**
 * call addSearcher handlers
 */


Controller.prototype.onAddSearcher = function () {
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = this.onAddSearcherHandlers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var onAddSearcherHandler = _step5.value;
      onAddSearcherHandler();
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }
};

Controller.prototype.fetchData = function (queryString, completeCallback, limit, timeout, source, type) {
  //search, none
  var queryBuilder = new QueryBuilder().queryString(queryString).limit(limit).type("list");
  if (source) queryBuilder.target({
    source: source,
    type: type ? type : null
  });
  var query = queryBuilder.build();

  if (query.queryString.length > 0 || query.queryString.length === 0 && this.blankBehavior === "search") {
    return this.fetchDataFromQueryObject(query, completeCallback);
  } else {
    var queryResult = new QueryResult(null);
    completeCallback(queryResult.getAllResults(), true);
    return Promise.resolve(queryResult.getAllResults());
  }
};

Controller.prototype.fetchDataFromQueryObject = function (callQuery, completeCallback) {
  //Is there an active DataFetcher? then cancel it
  if (this.activeDataFetcher !== null) {
    this.activeDataFetcher.cancel();
    this.activeDataFetcher = null;
  } //Create new DataFetcher


  this.activeDataFetcher = new DataFetcher(this, completeCallback);
  var fetchQueries = [];
  var searchersToFetchFrom = this.getTargetedSearchersFromQuery(callQuery);
  var typeCount = callQuery.hasTarget ? 1 : this.getTypeCount(searchersToFetchFrom);

  if (typeCount === 0) {
    return Promise.resolve([]);
  } else if (typeCount === 1) {
    var fetchQueryBuilder = new QueryBuilder(callQuery);
    fetchQueryBuilder.type("list").limit(100);
    var fetchQuery = fetchQueryBuilder.build();
    fetchQuery.searcher = searchersToFetchFrom[0];
    fetchQueries.push(fetchQuery);
  } else {
    var fairShare = Math.ceil(callQuery.limit / typeCount);
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = searchersToFetchFrom[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var searcher = _step6.value;

        var _fetchQueryBuilder = new QueryBuilder(callQuery);

        var minimumShowCount = searcher.minimumShowCount;

        if (minimumShowCount === 0) {
          if (callQuery.isBlank) _fetchQueryBuilder.type("collapse");else _fetchQueryBuilder.type("no-cut").limit(fairShare);
        } else {
          var limit = void 0;
          if (callQuery.isBlank && !searcher.showMinimumOnBlank) limit = fairShare;else limit = Math.max(fairShare, minimumShowCount);
          if (limit < 3) limit = 0;

          _fetchQueryBuilder.type("cut").limit(limit);
        }

        var _fetchQuery = _fetchQueryBuilder.build();

        _fetchQuery.searcher = searcher;
        fetchQueries.push(_fetchQuery);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }

  return this.activeDataFetcher.fetch(fetchQueries);
};

Controller.prototype.getTargetedSearchersFromQuery = function (query) {
  if (query.hasTarget) {
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = this._searchers[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var thisSearcher = _step7.value;
        if (thisSearcher.hasTarget(query.target)) if (query.isBlank && thisSearcher.blankBehavior === 'none') return [];else return [thisSearcher];
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    return [];
  } else {
    return this._searchers;
  }
};

Controller.prototype.getSearcherBySourceType = function (source, type) {
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = this._searchers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var thisSearcher = _step8.value;
      if (thisSearcher.hasSource(source) && thisSearcher.hasType(type)) return thisSearcher;
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return null;
};

Controller.prototype.getTypeCount = function (searchers) {
  var count = 0;
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = searchers[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var thisSearcher = _step9.value;
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = thisSearcher.getSources()[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var thisSource = _step10.value;
          count += thisSource.types.length;
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  return count;
};

Controller.prototype.get =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(source, type, id) {
    var searcher, result, completeResult;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.allSearchersProcessed;

          case 2:
            searcher = this.getSearcherBySourceType(source, type);

            if (!(searcher === null)) {
              _context3.next = 7;
              break;
            }

            throw new Error("Controller.get: could not find searcher");

          case 7:
            _context3.next = 9;
            return searcher.ready();

          case 9:
            _context3.next = 11;
            return searcher.get(id, type, source);

          case 11:
            result = _context3.sent;

            if (!(typeof result === 'undefined' || result === null)) {
              _context3.next = 14;
              break;
            }

            throw new Error("Controller.get: could not find object");

          case 14:
            _context3.next = 16;
            return result.searcher.completeResult(result);

          case 16:
            completeResult = _context3.sent;

            if (!(completeResult === null)) {
              _context3.next = 19;
              break;
            }

            throw new Error("Controller.get: completeResult === null");

          case 19:
            return _context3.abrupt("return", completeResult);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

Controller.prototype.cancelFetches = function () {
  //Is there an active DataFetcher? then cancel it
  if (this.activeDataFetcher !== null) {
    this.activeDataFetcher.cancel();
    this.activeDataFetcher = null;
  }
};

Controller.prototype.getSources =
/*#__PURE__*/
_asyncToGenerator(
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee4() {
  var sources, getSource, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, thisSearcher, thisSearcherSources, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, thisSearcherSource, source;

  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return this.allSearchersProcessed;

        case 2:
          sources = []; //Internal helper function

          getSource = function getSource(sourceName) {
            for (var i = 0; i < sources.length; i++) {
              if (sources[i].source.toLowerCase() === sourceName.toLowerCase()) return sources[i];
            } //Else create the source


            var source = {
              source: sourceName,
              types: []
            };
            sources.push(source);
            return source;
          };

          _iteratorNormalCompletion11 = true;
          _didIteratorError11 = false;
          _iteratorError11 = undefined;
          _context4.prev = 7;
          _iterator11 = this._searchers[Symbol.iterator]();

        case 9:
          if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
            _context4.next = 34;
            break;
          }

          thisSearcher = _step11.value;
          thisSearcherSources = thisSearcher.getSources();
          _iteratorNormalCompletion12 = true;
          _didIteratorError12 = false;
          _iteratorError12 = undefined;
          _context4.prev = 15;

          for (_iterator12 = thisSearcherSources[Symbol.iterator](); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            thisSearcherSource = _step12.value;
            source = getSource(thisSearcherSource.source);
            source.types = source.types.concat(thisSearcherSource.types);
          }

          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](15);
          _didIteratorError12 = true;
          _iteratorError12 = _context4.t0;

        case 23:
          _context4.prev = 23;
          _context4.prev = 24;

          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }

        case 26:
          _context4.prev = 26;

          if (!_didIteratorError12) {
            _context4.next = 29;
            break;
          }

          throw _iteratorError12;

        case 29:
          return _context4.finish(26);

        case 30:
          return _context4.finish(23);

        case 31:
          _iteratorNormalCompletion11 = true;
          _context4.next = 9;
          break;

        case 34:
          _context4.next = 40;
          break;

        case 36:
          _context4.prev = 36;
          _context4.t1 = _context4["catch"](7);
          _didIteratorError11 = true;
          _iteratorError11 = _context4.t1;

        case 40:
          _context4.prev = 40;
          _context4.prev = 41;

          if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
            _iterator11.return();
          }

        case 43:
          _context4.prev = 43;

          if (!_didIteratorError11) {
            _context4.next = 46;
            break;
          }

          throw _iteratorError11;

        case 46:
          return _context4.finish(43);

        case 47:
          return _context4.finish(40);

        case 48:
          return _context4.abrupt("return", sources);

        case 49:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, this, [[7, 36, 40, 48], [15, 19, 23, 31], [24,, 26, 30], [41,, 43, 47]]);
}));

Controller.prototype.getSearchers = function () {
  return this._searchers;
};

Controller.prototype.getSearcherFromId = function (id) {
  for (var i = 0; i < this._searchers.length; i++) {
    if (this._searchers[i].getId() == id) return this._searchers[i];
  }

  return null;
};

Controller.prototype.fetchError = function (dataFetcher, searcher, errorThrown) {
  if (dataFetcher === this.activeDataFetcher) this.onError(searcher, errorThrown);
};

Controller.prototype.CLASS_NAME = 'Septima.Search.Controller';